//cartao de visita e alfandega ////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import { userKey } from '../../global'
import store from '../store'
import router from '../router'
///////////////////////////////////////////////////////////////////////////////////////////////////

let VueScrollTo = require('vue-scrollto');                  //Efetua rolagem da pagina para o topo

///////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
//Avalia tipo do usuario e destina a rigor/////////////////////////////////////////////////////////
export function ekarApyaba ( usuario, urlAtual ) {

    let alvo = 0;                               //index do destino
            
    if (usuario.hion) {                         //Caso colaborador Hion
        //Avalia o privilegio atual deste colaborador /////////////////////////////////////
        if (usuario.status == 'ativo' || usuario.status == 'ferias') {          //granted
            if ((usuario.prt & 0b10000000) && (usuario.prt & 0b00000001)) alvo = 1;
            else if ((usuario.prt & 0b00000010) && (usuario.prt & 0b00000001)) alvo = 2;
            else if ((usuario.prt & 0b00001000) && (usuario.prt & 0b00000001)) alvo = 3;
            else alvo = 0;  //se cair no else houve erro de execucao
        } else { //denied - perfil não ativo
            Vue.toasted.global.defaultError({ msg : 'Para acessar a plataforma seu perfil HION deve estar ativo!!!' });
            store.commit('setUser', null);
            window.localStorage.removeItem(userKey);
            if (urlAtual !== '/Login') router.push({ name: 'Auth' });
            return
        } /////////////////////////////////////////////////////////////////////////////////
    } else {                                    //Caso cliente Hion
        //Avalia o privilegio atual deste cliente /////////////////////////////////////////
        if (usuario.status == 'ativo') { //granted
            alvo = usuario.nivel + 3;
            if (alvo <= 3) alvo = 0; //se cair no if houve erro de execucao
        } else { //denied - perfil não ativo
            Vue.toasted.global.defaultError({ msg : 'Para acessar a plataforma seu perfil HION deve estar ativo!!!' });
            //falta implementar redirecionamento para ativar perfil qdo cliente for administrador
            store.commit('setUser', null);
            window.localStorage.removeItem(userKey); 
            if (urlAtual !== '/Login') router.push({ name: 'Auth' });
            return
        } /////////////////////////////////////////////////////////////////////////////////
    }
    ///////////////////////////////////////////////////////////////////////////////////////

    //registra na store da App e do Client ////////////////////////////////////////////////
    if (urlAtual === '/Login') {
        window.localStorage.removeItem(userKey);                    //remove usuario antigo
        store.commit('setUser', null)                               //remove da store
        store.commit('setUser', usuario)                            //atualiza store com novo usuario
        window.localStorage.setItem(userKey, JSON.stringify(usuario))//atualiza localStorage
    }
    ///////////////////////////////////////////////////////////////////////////////////////
    
    VueScrollTo.scrollTo('.header', 1000);
    
    //Efetua redirecionamento para Home da Plataforma interativa //////////////////////////
    switch (alvo) {
        case 0:
                Vue.toasted.global.defaultError({ msg : 'Ocorreu algum problema com sua autenticação! Por favor tente novamente!!!' });
                store.commit('setUser', null);
                window.localStorage.removeItem(userKey);
                if (urlAtual !== '/Login') router.push({ name: 'Auth' });
            return;
        case 1: if (urlAtual !== '/PlataformaHION/Socio')       router.push({ name: 'HomeHionSocio'   }); break;
        case 2: if (urlAtual !== '/PlataformaHION/Dev')         router.push({ name: 'HomeHionDev'     }); break;
        case 3: if (urlAtual !== '/PlataformaHION/Adm')         router.push({ name: 'HomeHionAdm'     }); break;
        case 4: if (urlAtual !== '/PlataformaHION/Admin')       router.push({ name: 'HomeInterativaN1'}); break;
        case 5: if (urlAtual !== '/PlataformaHION/perfil')      router.push({ name: 'HomeInterativaN2'}); break;
        case 6: if (urlAtual !== '/PlataformaHION/encarregado') router.push({ name: 'HomeInterativaN3'}); break;
        case 7: if (urlAtual !== '/PlataformaHION/operador')    router.push({ name: 'HomeInterativaN4'}); break;
        default:
                Vue.toasted.global.defaultError({ msg : 'Ocorreu algum problema com sua autenticação! Por favor tente novamente!!!' });
                store.commit('setUser', null);
                window.localStorage.removeItem(userKey); 
                if (urlAtual !== '/Login') router.push({ name: 'Auth' });
            return;
    }
}
///////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////

export default { ekarApyaba }